import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useAppSelector} from '../../app/hooks';
import { selectWallet } from './walletSlice';

export default function Wallet(props:any) {
    const {theme} = props
    const wallet = useAppSelector(selectWallet);
    const [walletBalance, setWalletBalance] = useState(0)
    const [stakedBalance, setStakedBalance] = useState(0)
    const [totalBalance, setTotalBalance] = useState(0)
    const [lpArr, setLpArr] = useState([])
    const [singleArr, setSingleArr] = useState([])

    useEffect(() => {
        const getBalances = async () => {
            let walletBalance:number = 0
            let stakedBalance:number = 0
            let totalBalance:number = 0
            let lpList:any = []
            let singleList:any = []
            
            for(const value of Object.values(wallet.allInfo)){
                const value1:any = value
                if(value1.walletValueInDollars){
                    walletBalance = walletBalance + value1.walletValueInDollars
                    walletBalance = Number(walletBalance)
                }
                if(value1.totalValueInPool){
                    stakedBalance = stakedBalance + value1.totalValueInPool
                    stakedBalance = Number(stakedBalance)
                }

                if(value1.sym.includes('LP')){
                    lpList.push(value1)
                }else{
                    singleList.push(value1)
                }
                
            }
            setWalletBalance(walletBalance)
            setStakedBalance(stakedBalance)
            totalBalance = walletBalance + stakedBalance
            setTotalBalance(totalBalance)
            setLpArr(lpList)
            setSingleArr(singleList)
        }
        getBalances()
        
        
    },[wallet])

    return (
        <StyledWallet>
            <br></br>
            {totalBalance > 0.0001 && <StyledBalances theme={theme}>
                <StyledBalanceText>Balance in wallet: ${walletBalance.toLocaleString(undefined, {maximumFractionDigits: 2})}</StyledBalanceText> 
                <StyledBalanceText>Balance in pools: ${stakedBalance.toLocaleString(undefined, {maximumFractionDigits: 2})}</StyledBalanceText>
                <StyledBalanceText>Balance total: ${totalBalance.toLocaleString(undefined, {maximumFractionDigits: 2})}</StyledBalanceText>
            </StyledBalances>}
            <br></br>
            {totalBalance > 0.0001 && <StyledHeader2>Single Tokens</StyledHeader2>}
            {totalBalance > 0.0001 && <StyledDetailsList theme={theme}>
                    <StyledTokenList>
                        <StyledDescriptionText>
                            <StyledSingleWord>Token</StyledSingleWord> 
                            <StyledSingleWord>Symbol</StyledSingleWord>
                        </StyledDescriptionText>
                        {singleArr.length > 0 && singleArr.map((single:any, i) => {
                            if(single.totalValueInPool || single.tokensInWallet !== '0.0'){
                                return (
                                    <StyledSingleText key={i}>{single.sym}</StyledSingleText>
                                )
                            }
                            return ''
                                   
                        })}
                    </StyledTokenList>
                  
                        
                    
                    <StyledTokenList>
                        <StyledDescriptionText>
                            <StyledSingleWord>Wallet</StyledSingleWord>
                            <StyledSingleWord>Amount</StyledSingleWord>
                        </StyledDescriptionText> 
                        {singleArr.length > 0 && singleArr.map((single:any, i) => {
                            if(single.tokensInWallet !== '0.0'){
                                return (
                                    <StyledSingleText key={i}> {single.walletValueInDollars ? `${Number(single.tokensInWallet) >= 0.01 ? Number(single.tokensInWallet).toFixed(2) : '<0.01'}` : <br></br>}</StyledSingleText>
                                )
                            }
                            return ''
                        })}
                    </StyledTokenList>

                    <StyledTokenList>
                        <StyledDescriptionText>
                            <StyledSingleWord>Wallet</StyledSingleWord> 
                            <StyledSingleWord>Value</StyledSingleWord>
                        </StyledDescriptionText>
                        {singleArr.length > 0 && singleArr.map((single:any, i) => {
                            if(single.walletValueInDollars || single.tokensInWallet !== '0.0'){
                                return (
                                        <StyledSingleText key={i}> {single.walletValueInDollars ? (`$${single.walletValueInDollars.toFixed(2) === '0.00' ? '<0.01' : single.walletValueInDollars.toFixed(2)}`) :  <br></br>}</StyledSingleText>
                                )
                            }
                            return ''
                        })}
                    </StyledTokenList>
                    
                
                    <StyledTokenList>
                        <StyledDescriptionText>
                            <StyledSingleWord>Staked</StyledSingleWord> 
                            <StyledSingleWord>Amount</StyledSingleWord>
                        </StyledDescriptionText>
                        {singleArr.length > 0 && singleArr.map((single:any, i) => {
                            if(single.stakeAllocationAmount || single.tokensInWallet !== '0.0'){
                                return (
                                    <StyledSingleText key={i}> {single.stakeAllocationAmount ? Number(single.stakeAllocationAmount).toFixed(3) : <br></br>}</StyledSingleText>
                                )
                            }
                            return ''
                        })}
                    </StyledTokenList>

                    <StyledTokenList>
                        <StyledDescriptionText>
                            <StyledSingleWord>Staked</StyledSingleWord> 
                            <StyledSingleWord>Value</StyledSingleWord>
                        </StyledDescriptionText>    
                        {singleArr.length > 0 && singleArr.map((single:any, i) => {
                            if(single.totalValueInPool || single.tokensInWallet !== '0.0'){
                                return (
                                    <StyledSingleText key={i}>{single.totalValueInPool ? `$${single.totalValueInPool.toFixed(2)}` : <br></br>}</StyledSingleText>
                                )
                            }
                            return ''
                        })}
                    </StyledTokenList>

                    <StyledTokenList>
                        <StyledDescriptionText>
                            <StyledSingleWord>Total</StyledSingleWord> 
                            <StyledSingleWord>Value</StyledSingleWord>
                        </StyledDescriptionText>    
                        {singleArr.length > 0 && singleArr.map((single:any, i) => {
                            if(single.totalValueInPool || single.walletValueInDollars){
                                const total = (single.totalValueInPool || 0) + (single.walletValueInDollars || 0);
                                return (
                                    <strong>
                                    <StyledSingleText key={i}>{total ? `$${total.toFixed(2)}` : <br></br>}</StyledSingleText>
                                    </strong>
                                )
                            }
                            return ''
                        })}
                    </StyledTokenList>
                </StyledDetailsList> }
            <br/>
            <br/>
            {totalBalance > 0.0001 && <StyledHeader2>LP Tokens</StyledHeader2>}
            {totalBalance > 0.0001 && <StyledDetailsList theme={theme}>           
                <StyledTokenList>
                    <StyledDescriptionText>
                        <StyledSingleWord>LP</StyledSingleWord> 
                        <StyledSingleWord>Symbol</StyledSingleWord>
                    </StyledDescriptionText>
                    {lpArr.length > 0 && lpArr.map((lpObj:any, i) => {
                        if(lpObj.totalValueInPool){
                            return (
                                <StyledLpText key={i}>{lpObj.sym}</StyledLpText>)
                        }
                        return <span key={i}></span>
                    })}
                </StyledTokenList>

                <StyledTokenList>
                    <StyledDescriptionText>
                        <StyledSingleWord>First</StyledSingleWord> 
                        <StyledSingleWord>Token</StyledSingleWord>
                    </StyledDescriptionText>
                    {lpArr.length > 0 && lpArr.map((lpObj:any, i) => {
                        if(lpObj.totalValueInPool){
                            return (
                                <StyledLpText key={i}>{lpObj.amountOfToken0 ? lpObj.amountOfToken0.toFixed(2) : 0.00} {lpObj[0]} <br/> (${lpObj.valueOfToken0Amount ? lpObj.valueOfToken0Amount.toFixed(2) : 0.00})</StyledLpText>
                                )
                        }
                        return <span key={i}></span>
                    })}
                </StyledTokenList>
                <StyledTokenList>
                    <StyledDescriptionText>
                        <StyledSingleWord>Second</StyledSingleWord> 
                        <StyledSingleWord>Token</StyledSingleWord>
                    </StyledDescriptionText>
                    {lpArr.length > 0 && lpArr.map((lpObj:any, i) => {
                        if(lpObj.totalValueInPool){
                            return (
                                <StyledLpText key={i}>{lpObj.amountOfToken1 ? lpObj.amountOfToken1.toFixed(2) : 0.00} {lpObj[1]} <br/> (${lpObj.valueOfToken1Amount ? lpObj.valueOfToken1Amount.toFixed(2): 0.00})</StyledLpText>
                                )
                        }
                        return <span key={i}></span>
                    })}
                </StyledTokenList>
                <StyledTokenList>
                    <StyledDescriptionText>
                        <StyledSingleWord>Staked</StyledSingleWord> 
                        <StyledSingleWord>Amount</StyledSingleWord>
                    </StyledDescriptionText>
                    {lpArr.length > 0 && lpArr.map((lpObj:any, i) => {
                        if(lpObj.totalValueInPool){
                            return (
                               <StyledLpText key={i}>{Number(lpObj.stakeAllocationAmount).toFixed(3)}</StyledLpText>
                                )
                        }
                        return <span key={i}></span>
                    })}
                </StyledTokenList>

                <StyledTokenList>
                    <StyledDescriptionText>
                        <StyledSingleWord>Staked</StyledSingleWord> 
                        <StyledSingleWord>Value</StyledSingleWord>
                    </StyledDescriptionText>
                    {lpArr.length > 0 && lpArr.map((lpObj:any, i) => {
                        if(lpObj.totalValueInPool){
                            return (
                    
                                <StyledLpText key={i}>${lpObj.totalValueInPool ? lpObj.totalValueInPool.toFixed(2) : 0.00}</StyledLpText>
                                )
                        }
                        return <span key={i}></span>
                    })}
                </StyledTokenList>
            </StyledDetailsList>}   
        </StyledWallet>
    );
  }

    const StyledHeader2 = styled.h2`
        font-size:3rem;
        /* @media(max-width:1000px){
            font-size:2.5rem;
        } */
        @media(max-width:750px){
            font-size:2.5rem;
        }    
        @media(max-width:600px){
        font-size:2.2rem;
        }
        @media(max-width:450px){
        font-size:1.8rem;
        }
    `

    const StyledBalances = styled.div`
        border:${(props:any) => (props.theme === 'dark' ? '5px solid #AEBBC6' : '5px solid black')};
        display:flex;
        flex-direction:column;
        align-items:flex-start;
        justify-items:space-around;
        gap:28px;
        padding:5px;
        height:140px;
    `

    const StyledLpText = styled.div`
        height:80px;
        width:100%;
        padding-top:4%;
        border-top:1px solid black;
        border-bottom:1px solid black;
        font-size:1.4rem;
        @media(max-width:600px){
            font-size:1rem;
            height:60px;
        }
        @media(max-width:400px){
            font-size:.7rem;
        }
    `
    const StyledBalanceText = styled.div`
        font-weight:bold;
    `

    const StyledSingleWord = styled.div`
        font-size:1.5rem;
        @media(max-width:600px){
            font-size:1rem;
        }
        @media(max-width:400px){
            font-size:.7rem;
        }
    `

    const StyledSingleText = styled.div`
        width:100%;
        padding-top:4%;
        border-top:1px solid black;
        border-bottom:1px solid black;
        font-size:1.4rem;
        height:32px;
        @media(max-width:600px){
            font-size:1rem;
        }
        @media(max-width:400px){
            font-size:.7rem;
        }
    `

    const StyledDescriptionText = styled.div`
        font-weight:bold;
        height:100px;
        width:100%;
        display:flex;
        flex-direction:column;
        justify-content:center;
    `


    const StyledDetailsList = styled.div`
    display:flex;
    padding:10px;
    background:${(props:any) => (props.theme === 'dark' ? '#232425' : 'white')};
    border:${(props:any) => (props.theme === 'dark' ? '4px solid #AEBBC6' : '4px solid black')};
    width:90%;
    @media(min-width:2000px){
        width:80%
    }
    `
    const StyledTokenList = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    border-right:1px solid black;
    width:25%;
    border-bottom: 1px solid black;
    border:1px solid black;
    `
  
  const StyledWallet = styled.div`
        display:flex;
        flex-direction:column;
        align-items:center;
        
    `
